// extracted by mini-css-extract-plugin
export default {"main":"WordsBattle_main__qeEBj","button_buy":"WordsBattle_button_buy__Y2F-i","button_try":"WordsBattle_button_try__PXDsr"};